import constants from './constants';

/**
 * Sanitizes input string to remove unicode chars greater than the defined byte size in UTF-8,
 * also limits to the defined number of chars
 */
const sanitizeAppStorageFileDescription = (description = '') => { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  const chars = [...description].slice(0, constants.FILE_DESCRIPTION_MAX_LENGTH); // using spread operator to treat emoji as individual char
  return chars.filter((char) => new Blob([char]).size <= constants.FILE_DESCRIPTION_CHAR_BYTE_MAX_SIZE).join('');
};

export {
  sanitizeAppStorageFileDescription,
};
